<div class="homeworkLoading alert alert-warning spacer-lg wide">
  <span>{{ 'HOMEWORK_LOADER.LOADING' | translate }}</span>
  <kh-img path="loading-blue-bar-anim.gif"></kh-img>
</div>